import { RtkqSpin } from '@app/base';
import { MyProviderListItem, useLazySearchProvidersByPatientQuery } from '@app/main/api';
import { EMPTY_OPTION_SOURCE, Option, OptionSource, createEntireLoadOptionSource } from '@webinex/antik';
import { orderBy } from 'lodash';
import { useMemo } from 'react';
import { formatters } from '@app/ui';
import { Typography } from 'antd';
import { Name } from '../components';

function map(value: MyProviderListItem): Option {
  return {
    label: (
      <div>
        <div>
          <Name value={value} />
        </div>
        <div className="ant-selected-none">
          <Typography.Text type="secondary">{value.email}</Typography.Text>
        </div>
      </div>
    ),
    value: value.id,
    _searchValue: `${value.firstName} ${value.lastName} ${value.email}`,
  };
}

export function usePatientProviderSearchOptionSource(args: {
  patientId: string;
  oneOfIds?: string[];
  active?: boolean;
  skip?: boolean;
}): OptionSource {
  const [fetchList, { currentData }] = useLazySearchProvidersByPatientQuery();
  const { patientId, oneOfIds, active = true, skip } = args;

  return useMemo(() => {
    if (skip) {
      return EMPTY_OPTION_SOURCE;
    }

    return createEntireLoadOptionSource({
      fn: () =>
        fetchList(
          {
            [RtkqSpin]: false,
            patientId,
            active,
          },
          true,
        )
          .unwrap()
          .then((values) => {
            values = oneOfIds ? values.filter((x) => oneOfIds.includes(x.id)) : values;
            return orderBy(values, (x) => [!x.active, formatters.name(x)]).map(map);
          }),
      searchBy: '_searchValue',
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchList, currentData, patientId, oneOfIds, skip, active]);
}
